export const ADD_BRAND_PRODUCT_ON_SUCCESS = 'ADD_BRAND_PRODUCT_ON_SUCCESS'
export const DROP_UPLOAD_KEYS_ON_SUCCESS = 'DROP_UPLOAD_KEYS_ON_SUCCESS'
export const DROP_UPLOAD_CODES_ON_SUCCESS = 'DROP_UPLOAD_CODES_ON_SUCCESS'
export const ADD_WHITELISTED_CREATORS_ON_SUCCESS = 'ADD_WHITELISTED_CREATORS_ON_SUCCESS'
